export enum PricingRoleTypesEnum {
  FACTORY_ADMIN = 'FACTORY_ADMIN'
}
